//lib
import type { SocialProfileType } from '@/types/socialProfileType';

import { formatAddedSocialProfile } from '@/lib/socialProfile';

// Types
import type { SocialProfilesAndGroupsCondensedListProps } from '@/components/composite/SocialProfiles/SocialProfilesAndGroupsCondensedList';
//Components
import ItemWrapper from '@/components/pages/reports/components/Items/ItemWrapper';

type SocialProfileItemProps = {
    item: SocialProfileType;
    size?: SocialProfilesAndGroupsCondensedListProps['size'];
    className?: string;
};

const SocialProfileItem = ({ item, size = 'sm', className }: SocialProfileItemProps) => {
    return (
        <ItemWrapper
            spList={[item]}
            mainContent={formatAddedSocialProfile(item).main_name}
            subContent={formatAddedSocialProfile(item).sub_name}
            size={size}
            className={className}
        />
    );
};

export default SocialProfileItem;
